// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"167":"select","286":"game-welcome","332":"instructions","485":"game","594":"about","774":"mode"}[chunkId] + "." + {"167":"23c6b019","286":"1ac8441d","332":"7bd4a7f8","485":"dace9f80","594":"fce92c9c","774":"32873bc7"}[chunkId] + ".js";
};